var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-5xl mx-auto space-y-8"},[_c('Registrations',{attrs:{"account-id":_vm.accountId}}),_c('Phones',{attrs:{"account-id":_vm.accountId}}),_c('Emails',{attrs:{"account-id":_vm.accountId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }